// Generated by CoffeeScript 2.7.0
var EdgeConfig, condition_edit_modal, user_boundary_select_comp;

import ConditionField from 'trunks/vue/admin/components/condition_fields/field.js';

import ConditionShowField from 'trunks/vue/admin/components/condition_show_fields/field.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import UserBoundaryConfig from 'trunks/vue/admin/components/yet_another_workflow/_user_boundary.js';

import PopoverFieldSelect from 'trunks/vue/admin/components/popover_field_select.js';

user_boundary_select_comp = UserBoundaryConfig;

condition_edit_modal = Vue.extend({
  components: {
    modal: Modal,
    'condition-field': ConditionField,
    'popover-field-select': PopoverFieldSelect
  },
  props: {
    graphGroupedConditions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    availableFieldsGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    edge: {
      type: Skylark.App.Model.YetAnotherWorkflow.Edge,
      required: true
    }
  },
  computed: {
    selectedIds: function() {
      return _.chain(this.graphGroupedConditions).map(function(group) {
        return _.map(group.conditions, function(condition) {
          return condition.getFieldConditionable().id;
        });
      }).flatten(true).value();
    }
  },
  template: `<modal title='流程条件'
       extendClass='condition-fields-modal'
       :backdrop='true'
       @openedChange='modalOpenChanged'
       ref='modalRef'>
  <template>
    <div class="graph-grouped-conditions" v-if='graphGroupedConditions.length'>
      <div class="group-item"
           v-for='group in graphGroupedConditions'
           :key='group.id'>
        <div class="group-item-name">{{ group.name }}</div>
        <div class="group-item-content">
          <condition-field v-for='condition in group.conditions'
                           :key='condition.uuid'
                           :condition='condition'
                           @removeCondition='removeConditionFunc' />
        </div>
      </div>
    </div>
    <div class="blankslate" v-else>
      <i class="slp-warning-circle-o"></i>
      <p>没有“流程条件”</p>
    </div>
  </template>
  <div class="modal-footer" slot='footer'>
    <div class="justify-between">
      <popover-field-select extendClass='field-select-popover'
                            :formatDataFunc='formatDataFunc'
                            :initialSelectedOptionIds='selectedIds'
                            @submitClicked='updateConditionableFields'>
        <template slot='trigger'>
          <span class="text-btn btn">添加流程条件</span>
        </template>
        <template slot='option-item-template' slot-scope='{ option }'>
          <div class="content text-ellipsis">
            <i :class="_fieldIcon(option)"></i>
            <span>{{ option.name }}</span>
          </div>
          <i class="tip" :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
        </template>
        <div slot='filter-blankslate' class="list-group-name">没有能引用的回传字段</div>
        <div slot='options-blankslate' class="list-group-name">没有能引用的回传字段</div>
      </popover-field-select>
      <div class="force-no-wrap">
        <button @click='dismissModal'>关闭</button>
      </div>
    </div>
  </div>
</modal>`,
  methods: {
    updateConditionableFields: function(result) {
      return _.each(result.groups, (group) => {
        var graph;
        // 该分组下是否有设置过条件，如果有则合并分组，没有则新建分组
        graph = _.find(this.graphGroupedConditions, function(item) {
          return item.source === group.source;
        });
        if (graph) {
          return _.each(group.options, (option) => {
            var condition;
            // 判断某个字段是否已经设置过条件，如果有设置过，目前先不处理，后续可能会改
            // 如果没有设置过，则新建一个该字段的条件
            condition = _.find(graph.conditions, function(item) {
              return item.getFieldConditionable() === option.own_option;
            });
            if (!condition) {
              return graph.conditions.push(Skylark.App.Model.YetAnotherWorkflow.Condition.createFieldCondition(option.own_option, this.edge));
            }
          });
        } else {
          return this.graphGroupedConditions.push({
            name: group.name,
            id: group.id,
            source: group.source,
            conditions: _.map(group.options, (option) => {
              return Skylark.App.Model.YetAnotherWorkflow.Condition.createFieldCondition(option.own_option, this.edge);
            })
          });
        }
      });
    },
    removeConditionFunc: function(condition) {
      var graph, i, index, len, ref, results;
      condition.delete();
      ref = this.graphGroupedConditions;
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        graph = ref[index];
        if (_.contains(graph.conditions, condition)) {
          // 去掉对应分钟里面的该条件
          graph.conditions = _.rejectFirst(graph.conditions, function(item) {
            return item === condition;
          });
          if (!graph.conditions.length) {
            // 如果该条件为最后一个条件，去掉该分组
            this.graphGroupedConditions.splice(index, 1);
          }
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    },
    formatDataFunc: function() {
      return _.map(this.availableFieldsGroups, function(group) {
        return {
          name: group.name,
          id: group.uuid,
          source: group.source,
          options: _.map(group.fields, function(field) {
            return {
              name: field.title,
              id: field.id,
              // own_option 是保证引用一致而添加的关联关系
              own_option: field
            };
          })
        };
      });
    },
    modalOpenChanged: function(opened) {
      if (!opened) {
        return this._emitChange();
      }
    },
    dismissModal: function() {
      return this.$refs.modalRef.close();
    },
    _fieldIcon: function(option) {
      return option.own_option.getTypeIcon();
    },
    _emitChange: function() {
      return this.$emit('conditionsChanged');
    }
  }
});

export default EdgeConfig = {
  props: {
    element: {
      type: Skylark.App.Model.YetAnotherWorkflow.Edge,
      required: true
    }
  },
  components: {
    'user-boundary-comp': user_boundary_select_comp,
    'condition-show': ConditionShowField
  },
  computed: {
    edge: function() {
      return this.element;
    },
    userBoundary: function() {
      return this.edge.userBoundaryCondition.user_boundary;
    }
  },
  data: function() {
    return {
      graphGroupedConditions: []
    };
  },
  template: `<div class="config-container">
  <div class="config-title">节点连接线属性</div>
  <user-boundary-comp title='范围条件'
                      :userBoundary='userBoundary'
                      @valueChanged='userBoundaryChangeFunc' />
  <div class="config-item">
    <div class="config-item-title justify-box">
      <span class="content text-ellipsis">流程条件</span>
      <div class="config-item-actions" @click.stop='openConditionEditModal'>
        <i class="slp-plus"></i>
      </div>
    </div>
    <div class="config-item-content graph-grouped-conditions">
      <div class="group-item"
           v-for='group in graphGroupedConditions'
           :key='group.id'>
        <div class="group-item-name vertical-middle">
          <i class="slp-list-square-o"></i>
          <span>{{ group.name }}</span>
        </div>
        <div class="fieldable-conditions">
          <condition-show v-for="condition in group.conditions"
                          extendClass='condition-item'
                          :key='condition.uuid'
                          :condition='condition' />
        </div>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    return this.graphGroupedConditions = this._groupConditions();
  },
  methods: {
    userBoundaryChangeFunc: function(ub) {
      this.edge.updateUserBoundaryCondition(ub);
      return this.edge.update();
    },
    openConditionEditModal: function() {
      return new condition_edit_modal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue("condition_edit_modal"),
        propsData: {
          graphGroupedConditions: this.graphGroupedConditions,
          availableFieldsGroups: this._getConditionableGraphs(),
          edge: this.edge
        }
      }).$on('conditionsChanged', () => {
        return this.edge.update();
      });
    },
    _getConditionableGraphs: function() {
      var child_graphs, flow, root_graph;
      root_graph = this.edge.graph.getRootGraph();
      flow = root_graph.flow;
      child_graphs = root_graph.getChildrenGraphs();
      return _.reduce([flow].concat([root_graph]).concat(child_graphs), (memo, graph) => {
        var group;
        group = this.__getConditionableFieldsGroupByGraph(graph);
        if (group) {
          memo.push(group);
        }
        return memo;
      }, []);
    },
    _groupConditions: function() {
      var groupedConditions;
      groupedConditions = _.groupBy(this.edge.conditions, function(condition) {
        var field, fieldable_type;
        field = condition.getFieldConditionable();
        fieldable_type = Skylark.App.Model.YetAnotherWorkflow.Graph.hasInstance(field.fieldable) ? 'graph' : 'flow';
        return `${fieldable_type}_${field.fieldable.id}`;
      });
      return _.map(groupedConditions, function(conditions) {
        var field;
        field = _.first(conditions).getFieldConditionable();
        return {
          id: field.fieldable.id,
          name: field.fieldable.name || field.fieldable.title || '',
          conditions: conditions,
          source: field.fieldable
        };
      });
    },
    __getConditionableFieldsGroupByGraph: function(graph) {
      var fields;
      fields = _.chain(graph.fields).map(function(field) {
        if (field.type.demodulize() === 'Detail') {
          return [field].concat(field.children || []);
        } else {
          return field;
        }
      }).flatten(true).filter(function(field) {
        return field.type.demodulize() === 'RadioButton';
      }).value();
      if (fields.length) {
        return {
          uuid: graph.uuid,
          name: graph.title || graph.name || '',
          fields: fields,
          source: graph
        };
      } else {
        return null;
      }
    }
  }
};
